(function () {
  const root = document.querySelector('[data-gs-sqft-calc]');
  if (!root) return;

  const dataEl = document.querySelector('[data-gs-sqft-data]');
  if (!dataEl) return;

  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const sqftInput = root.querySelector('[data-gs-input="sqft"]');
  const boxInput = root.querySelector('[data-gs-input="boxes"]');
  const wastageInput = root.querySelector('[data-gs-wastage]');
  const summaryEl = root.querySelector('[data-gs-summary]');

  const form = document.querySelector('form[action*="/cart/add"]');
  const variantIdInput = form ? form.querySelector('[name="id"]') : null;

  const fmt = new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: data.currency || 'CAD'
  });

  function fmtCoverage(n) {
    return Number(n.toFixed(2)).toString();
  }

  function getCurrentVariant() {
    if (!variantIdInput || !variantIdInput.value) return null;
    return data.variants[variantIdInput.value] || null;
  }

  function getQtyInput() {
    return form ? form.querySelector('[name="quantity"]:not([type="hidden"])') : null;
  }

  let lastInput = 'boxes';
  let syncing = false;

  function recalculate() {
    const variant = getCurrentVariant();
    if (!variant || !variant.coverage) {
      summaryEl.hidden = true;
      return;
    }

    let boxes;

    if (lastInput === 'sqft') {
      const userSqft = parseFloat(sqftInput.value) || 0;
      if (userSqft <= 0) { summaryEl.hidden = true; return; }
      const wastageFactor = wastageInput.checked ? 1.10 : 1.0;
      const sqftNeeded = Math.round(userSqft * wastageFactor * 100) / 100;
      boxes = Math.ceil((sqftNeeded - 0.0001) / variant.coverage);
    } else {
      const userBoxes = parseInt(boxInput.value, 10) || 0;
      if (userBoxes <= 0) { summaryEl.hidden = true; return; }
      boxes = userBoxes;
    }

    syncing = true;
    if (parseInt(boxInput.value, 10) !== boxes) boxInput.value = boxes;
    if (lastInput !== 'sqft' || sqftInput.value === '') {
      sqftInput.value = fmtCoverage(boxes * variant.coverage);
    }
    const qty = getQtyInput();
    if (qty && parseInt(qty.value, 10) !== boxes) {
      qty.value = boxes;
    }
    if (qty && form) {
      const minBox = parseInt(qty.min, 10) || 1;
      const minusBtn = form.querySelector('button[name="minus"]');
      if (minusBtn) {
        if (boxes > minBox) minusBtn.removeAttribute('disabled');
        else minusBtn.setAttribute('disabled', '');
      }
    }
    syncing = false;

    const totalCoverage = boxes * variant.coverage;
    const totalPrice = (boxes * variant.price_cents) / 100;

    const unitNoun = boxes === 1 ? data.unit_singular : data.unit_plural;
    const coverVerb = boxes === 1 ? 'covers' : 'cover';
    const costVerb = boxes === 1 ? 'costs' : 'cost';

    summaryEl.innerHTML =
      'You need <strong>' + boxes + ' ' + unitNoun + '</strong> which ' + coverVerb +
      ' <strong>' + fmtCoverage(totalCoverage) + ' sq. ft.</strong><br>' +
      'Total cost: <strong>' + fmt.format(totalPrice) + '</strong>';
    summaryEl.hidden = false;
  }

  sqftInput.addEventListener('input', function () {
    if (syncing) return;
    lastInput = 'sqft';
    recalculate();
  });

  boxInput.addEventListener('input', function () {
    if (syncing) return;
    lastInput = 'boxes';
    recalculate();
  });

  wastageInput.addEventListener('change', recalculate);

  if (form) {
    let lastQtyValue = null;
    setInterval(function () {
      if (syncing) return;
      const qty = getQtyInput();
      if (!qty) return;
      if (qty.value === lastQtyValue) return;
      lastQtyValue = qty.value;
      const newQty = parseInt(qty.value, 10) || 0;
      if (newQty <= 0) return;
      if (parseInt(boxInput.value, 10) === newQty) return;
      boxInput.value = newQty;
      lastInput = 'boxes';
      recalculate();
    }, 200);
  }

  if (variantIdInput) {
    let lastVariantId = variantIdInput.value;
    new MutationObserver(function () {
      if (variantIdInput.value !== lastVariantId) {
        lastVariantId = variantIdInput.value;
        recalculate();
      }
    }).observe(variantIdInput, { attributes: true, attributeFilter: ['value'] });
  }

  boxInput.value = 1;
  lastInput = 'boxes';
  recalculate();
})();